import { makeStyles } from "@material-ui/styles";

const gameControlStyles = makeStyles(() => ({
	errorMessageContainer: {
		padding: 10,
		maxWidth: "fit-content"
	}
}));

export default gameControlStyles;
